class BESSAppProjectInitiativesProfilerManager extends BESSAppProjectProfilerManager {

    start() {
        super.start();
        this.#updateState();
    }


    updated() {
        super.updated();
        this.#updateState();
    }

    #updateState() {
        this._forEachItem(this.#updateStateForItem);
    }

    #updateStateForItem(itemData) {
        if (itemData.valueFor.initiative) {
            let isInnovationLibraryItem = itemData.valueFor.initiative.value !== 'O';
            this.forEach(this.profiler.items, function (item) {
                if (item.item === itemData) {
                    item.getField('pointsTargeted').showIf(!isInnovationLibraryItem);
                    item.getField('points').showIf(isInnovationLibraryItem);
                }
            });
        }
    }
}